import React from 'react';
import '../../assets/css/homepage.css';
import {isNullOrUndefined , getOS } from "../modules/CommonFunctions";
import {Line} from '@vds/lines';
import styled from 'styled-components';
import {Title} from '@vds/typography';
import AccountImage from "../../assets/resources/images/my-account-blk.png";
import InternetImage from "../../assets/resources/images/modem-router-blk.png";
import PhoneImage from "../../assets/resources/images/phone-alt-blk.png";
import TVImage from "../../assets/resources/images/tv-blk.png";
import CaretImage from "../../assets/resources/images/caret.png";
import {setNativeTitleWithNavigation, getValuesFromUserAgent, nativeBackAction,versionCompare,nativeHideTopBar,nativeUpdateFab} from "../../actions/native";
import { RTCICall, MetricRTCICall } from "./RTCICall";
import { HOME_PAGE_CATEGORY } from '../../constants/constants';
import {Loader} from"@vds/loaders";
const StyledLineNext = styled.div `height:3px`
const StyledLineLight = styled.div `height:2px`


class HomePageTabOneApp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSpinnerActive: false      
        }
        this.isValidUser = document.cookie.indexOf('userinfo') > -1 ? true : false;
        this.pegaID = (this.isValidUser && !isNullOrUndefined(window.homePageDynamicData.Attribute) && !isNullOrUndefined(window.homePageDynamicData.Attribute.content)) ? window.homePageDynamicData.Attribute.content : "";
        this.CheckIndex =0;
        this.ValidRow = false;  
         this.tabcount = -1;    
        localStorage.removeItem("ParentPageName");
    }

    viewProfile(e) {
        this.setState({isSpinnerActive: true})
        let index = e.currentTarget.getAttribute('data-index');
        let guidedTitle = this.props.TabData[index].collist[0].topsollist[0].title;
        var guidedlist = this.props.TabData[index].collist[0].topsollist[0].topsolutions;
        let HomeTitle = e.currentTarget.getAttribute('data-title');
        let relevantTitle ="";
        var relevantlist ="";

        if(HomeTitle != "Billing & Account")
        {
            relevantTitle =this.props.TabData[index].collist[0].topsollist[1].title;
            relevantlist = this.props.TabData[index].collist[0].topsollist[1].topsolutions;
        }
              
        localStorage.removeItem("GuidedTitle");
        localStorage.setItem('GuidedTitle',guidedTitle);

        localStorage.removeItem("GuidedItems");
        localStorage.setItem('GuidedItems',JSON.stringify(guidedlist));

        localStorage.removeItem("RelevantTitle");
        localStorage.setItem('RelevantTitle',relevantTitle);

        localStorage.removeItem("RelevantItems");
        localStorage.setItem('RelevantItems',JSON.stringify(relevantlist));

        localStorage.removeItem("HomeTitle");
        localStorage.setItem('HomeTitle',HomeTitle);

        let args = {
            os: getOS(),
            category: HOME_PAGE_CATEGORY,
            subCategory: null,
            pegaSessionID: this.pegaID,
            userid: (this.isValidUser) ? window.userinfo.userId : "",
            visionID: (this.isValidUser) ? window.userinfo.visionId : "",
            accountID: (this.isValidUser) ? window.userinfo.visionAcctId : ""
        }
        let navpath ="/support/"+window.domain_url+"/homeoneappsubsequent";
        window.location.href = navpath
        setTimeout(() => {
            if(window.location.href.includes("/homeoneappsubsequent")){
                this.setState({isSpinnerActive: false})   
            }     
        }, 10); 
        
        //window.constructScData('tab', Title);
        MetricRTCICall(args , Title);   
    }
    componentDidMount() {
      let stitle = document.querySelector("title");
      stitle.setAttribute("aria-hidden", true);
      stitle.innerHTML = "";
      stitle.innerText = "";
      stitle.innerHTML = "Verizon Support";
      stitle.innerText = "Verizon Support";
      let operatingSystem = getOS();
      let intent = "";
      let args = {
        homepage_name: "Residential Help",
        intentCategory: "ONEAPPHOME_DISPLAY",
        activityCategory: "ONEAPPHOME_DISPLAY",
        intent: intent,
        app_n_channel: "ONEAPPHOME-ESUPPORT",
        os: operatingSystem,
        pegaSessionID: "",
        userid: this.isValidUser ? window.userinfo.userId : "",
        visionID: this.isValidUser ? window.userinfo.visionId : "",
        accountID: this.isValidUser ? window.userinfo.visionAcctId : "",
      };
      RTCICall(args);
      const { channelId, version } = getValuesFromUserAgent(
        navigator.userAgent
      );
      if (
        (versionCompare(version, "11.1.0") &&
          channelId.toUpperCase() === "VZW-MFA-IOS") ||
        (versionCompare(version, "18.2.0") &&
          channelId.toUpperCase() === "VZW-MFA-ANDROID")
      ) {
        nativeBackAction("Support" ,true);
      } else {
        setNativeTitleWithNavigation("Support", true);
        nativeHideTopBar(true);
      }
      nativeUpdateFab(true);
    }

    OpenUrls(value){
        
        let LocationUrl ;
        let PageTitleValue ;
        if(value == 'Repair'){
            PageTitleValue = "Repair Status" ;
        }
        if(value == 'Equipment'){
            PageTitleValue = "Equipment Return" ;
        }
        if(value == 'FiosStore'){
            PageTitleValue = "Fios Store Locations" ;
        }
        //   setNativeTitleWithNavigation(PageTitleValue, true);
          nativeHideTopBar(true);
       let args = {
            os: getOS(),
            category: HOME_PAGE_CATEGORY,
            subCategory: null,
            pegaSessionID: this.pegaID,
            userid: (this.isValidUser) ? window.userinfo.userId : "",
            visionID: (this.isValidUser) ? window.userinfo.visionId : "",
            accountID: (this.isValidUser) ? window.userinfo.visionAcctId : ""
        }
        MetricRTCICall(args , PageTitleValue);
        //window.constructScData('tab', PageTitleValue);

        if(value == 'Repair'){
            LocationUrl ="";
            LocationUrl = 'https://www.verizon.com/foryourhome/vzrepair/flowengine/UFDRedirector.aspx?Keyword=REPAIR_STATUS';
        }
        if(value == 'Equipment'){
            LocationUrl ="";
            if (document.location.href.indexOf('www98') > -1) {
               LocationUrl = 'https://www98.verizon.com/support/residential/equipment-return';
            }else{
                LocationUrl = 'https://www.verizon.com/support/residential/equipment-return'; 
            }
        }
        if(value == 'FiosStore'){
            LocationUrl ="";
            LocationUrl = 'https://www.verizon.com/stores/storesearchresults/?fios=y&sourceType=MVA';
        }
        window.location.href = LocationUrl
    
    }

    render() {
        let localInstance = this;
        let LoadImage;
        let imgcss;
        let tileheadingcss;
        let titlevoice;
        let careticon;

        let navpath ="/support/"+window.domain_url+"/homeoneappsubsequent";
        this.careticon =CaretImage;
        const nodecoration={
            "textDecoration": 'none'
        }
       

        return (            
            <div className="MainScroll">                 
                                        
                <div className="article-list">
                   <div className="Helorow"> 
                        <h1 >I need help with...</h1>
                    </div>
                    <div className="Helorow"> 
                        <Line />
                    </div>
                        {
                        this.props.TabData.map((item, index) => {
                        if ((localInstance.props.AvailableDevices.indexOf(item.tabHeading.toLowerCase()) > -1) && item.tabHeading != "Overview") {
                        this.tabcount = this.tabcount + 1; 
                        if(item.tabHeading ==="Billing & Account"){
                            this.LoadImage = AccountImage;
                            this.imgcss = "billingaccounticon";
                            this.tileheadingcss = "padding-left-small"; 
                            this.titlevoice = item.tabHeading +" link double tap to activate";                  
                        }
                        else if(item.tabHeading ==="Internet"){
                            this.LoadImage = InternetImage;
                            this.imgcss = "interneticon";
                            this.tileheadingcss = "padding-left-small";
                            this.titlevoice = item.tabHeading +" link double tap to activate";  
                        }else if(item.tabHeading ==="Phone"){
                            this.LoadImage = PhoneImage;
                            this.imgcss = "phoneicon";
                            this.tileheadingcss = "padding-left-medium";
                            this.titlevoice = item.tabHeading +" link double tap to activate"; 
                        }else{
                            this.LoadImage = TVImage;
                            this.imgcss = "tvicon";
                            this.tileheadingcss = "padding-left-small";
                            this.titlevoice = item.tabHeading +" link double tap to activate"; 
                        }                      
                        this.CheckIndex = index;
                        this.AvailableDeviceCount;
                        if(window.hpInitResp.a_s.length > 0 && window.hpInitResp.a_s !="ALL"){
                            this.AvailableDeviceCount = window.hpInitResp.a_s.length ;
                        }else{
                            this.AvailableDeviceCount = localInstance.props.AvailableDevices.length-2;
                        }
                        if(this.tabcount ==this.AvailableDeviceCount){
                            this.ValidRow = true;
                        }
                        return(                            
                            <div id="divmain" key={index}>    
                            <div className="HomeBody">
                            <div role='link' data-track={item.tabHeading} className="removelink" data-index={index} data-title={item.tabHeading} 
                                onClick={this.viewProfile.bind(this)}>
                                <div className="BoldSubtitle"  >
                                {this.state.isSpinnerActive && <Loader 
                                   active ={true}
                                   fullscreen={false} 
                                />}
                                    <img src={this.LoadImage} alt=" " className={this.imgcss} aria-hidden="true"></img>  
                                    <span className={this.tileheadingcss} aria-label={item.tabHeading + " link double tap to activate"}>{item.tabHeading}</span>
                                    <span className="CaretArrow"> 
                                        <img src={this.careticon} alt=" " aria-hidden="true" ></img> 
                                    </span>
                                </div>
                            </div>
                            </div>
                            {
                                !this.ValidRow && 
                                <div className="Helorow" > 
                                    <StyledLineLight>
                                    <Line type="xLight"/>
                                    </StyledLineLight>
                                </div>
                            }
                            </div>
                            );
                        }
                        })
                    }

                    <div className="Helorow" > 
                        <StyledLineNext>
                        <Line type="light"/>
                        </StyledLineNext>
                    </div>
                </div>

                {/* Repair Status */}
                <div className="HomeBody">
                <a role="link" data-track="Repair Status" className="removelink" tabIndex="0" >
                    <div   className="BoldSubtitle" onClick={() => this.OpenUrls('Repair')}>
                        <span aria-label="Repair Status link double tap to activate"> Repair Status</span>
                        <span className="CaretArrow"> 
                            <img src={this.careticon} alt=" " aria-hidden="true" ></img> 
                        </span>
                    </div>
                </a>
                </div>

                <div className="Helorow" > 
                        <StyledLineLight>
                        <Line type="xLight"/>
                        </StyledLineLight>
                </div>

                {/* Equipment Return */}
                <div className="HomeBody">
                <a role="link" data-track="Equipment Return" className="removelink" tabIndex="0">
                    <div  className="BoldSubtitle" onClick={() => this.OpenUrls('Equipment')}>
                        <span aria-label="Equipment Return link double tap to activate">Equipment Return</span>
                        <span className="CaretArrow"> 
                            <img src={this.careticon} alt=" " aria-hidden="true" ></img> 
                        </span>     
                    </div> 
                    </a>            
                </div>

                <div className="Helorow"> 
                        <StyledLineLight>
                        <Line type="xLight"/>
                        </StyledLineLight>
                </div>      

                {/* Fios Store Locations */}
                <div className="HomeBody">
                <a role="link" data-track="Fios Store Locations" className="removelink" tabIndex="0">
                    <div  className="BoldSubtitle" onClick={() => this.OpenUrls('FiosStore')}>
                        <span aria-label="Fios Store Locations link double tap to activate">Fios Store Locations</span>
                        <span className="CaretArrow"> 
                            <img src={this.careticon} alt=" " aria-hidden="true" ></img>
                        </span>
                    </div>
                    </a>                  
                </div>

                <div className="Helorow" > 
                    <StyledLineNext>
                    <Line />
                    </StyledLineNext>
                </div>  
                            
            
            </div>
        );
    }
}

export default HomePageTabOneApp



// WEBPACK FOOTER //
// ./src/components/modules/HomePageTabOneApp.js